import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const CURVE_PATH = 'M30 90 Q70 30 100 72 Q130 110 170 60';
const CYCLE_MS = 5000;

export default function DeliveryAnimation({ trigger }) {
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    if (!trigger) return;
    const id = setInterval(() => setCycle((c) => c + 1), CYCLE_MS);
    return () => clearInterval(id);
  }, [trigger]);

  return (
    <svg viewBox="0 0 200 140" fill="none" className="w-full h-full">
      {/* Static dotted curved path */}
      <path d={CURVE_PATH} stroke="#E5E7EB" strokeWidth="2" strokeDasharray="5 4" fill="none" />

      {/* Start dot */}
      <circle cx="30" cy="90" r="4" fill="#FFD5D9" />

      {/* House icon — always visible */}
      <g>
        <rect x="158" y="52" width="24" height="18" rx="2" fill="white" stroke="#D1D5DB" strokeWidth="1.2" />
        <path d="M155 54l15-12 15 12" stroke="#FF6B81" strokeWidth="1.5" fill="#FFE0E3" strokeLinejoin="round" />
        <rect x="167" y="58" width="6" height="12" rx="1" fill="#FF6B81" />
        <rect x="176" y="56" width="4" height="4" rx="0.5" fill="#FFE0E3" stroke="#FF6B81" strokeWidth="0.5" />
      </g>

      {/* Animated elements — remount each cycle */}
      {trigger && (
        <g key={cycle}>
          {/* Colored path that draws ahead of the package */}
          <motion.path
            d={CURVE_PATH}
            stroke="#FFD5D9"
            strokeWidth="2.5"
            fill="none"
            initial={{ pathLength: 0, opacity: 1 }}
            animate={{
              pathLength: [0, 1, 1, 1],
              opacity:    [1, 1, 1, 0],
            }}
            transition={{
              duration: 4.0,
              times: [0, 0.5, 0.8, 1],
              ease: 'easeInOut',
            }}
          />

          {/* Package box traveling along the curved path */}
          <motion.g
            initial={{ x: 0, y: 0, opacity: 1 }}
            animate={{
              x:       [0, 35, 70, 105, 138, 138],
              y:       [0, -40, -12, -20, -30, -30],
              opacity: [1, 1,  1,   1,   0,   0],
            }}
            transition={{
              duration: 2.5,
              times: [0, 0.25, 0.5, 0.75, 0.92, 1],
              ease: 'easeInOut',
            }}
          >
            <rect x="22" y="78" width="20" height="16" rx="3" fill="#FF6B81" />
            <line x1="22" y1="86" x2="42" y2="86" stroke="white" strokeWidth="0.8" />
            <line x1="32" y1="78" x2="32" y2="94" stroke="white" strokeWidth="0.8" />
            <circle cx="32" cy="86" r="2" fill="white" />
          </motion.g>

          {/* Delivered checkmark at the house */}
          <motion.g
            initial={{ scale: 0, opacity: 0 }}
            animate={{
              scale:   [0, 0, 1.3, 1, 1, 0],
              opacity: [0, 0, 1,   1, 1, 0],
            }}
            transition={{
              duration: 4.0,
              times: [0, 0.52, 0.62, 0.7, 0.85, 0.97],
              ease: 'easeOut',
            }}
            style={{ transformOrigin: '182px 38px' }}
          >
            <circle cx="182" cy="38" r="8" fill="#2FAF7F" />
            <path d="M178 38l3 3 5-6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </motion.g>
        </g>
      )}
    </svg>
  );
}
